import { gql } from '@apollo/client';

const MARK_REPORT_ARTIFACT_MUTATION = gql`
  mutation markReportAsArtifactReport($id: ID!, $isArtifactReport: Boolean!) {
    markReportAsArtifactReport(id: $id, isArtifactReport: $isArtifactReport) {
      isSuccess
      message
    }
  }
`;

export default MARK_REPORT_ARTIFACT_MUTATION;
